
import  i18n  from 'i18next'
import enUsTrans from './en.json'
import zhUsTrans from './zh.json'
// import { initReactI18next } from 'react-i18next'
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector'

var jsScr = navigator.language.toLowerCase()
var defaultLng = "en"
// if (jsScr.indexOf('zh') >= 0) {

//     defaultLng = 'zh'
// } 

i18n.use(initReactI18next) // passes i18n down to react-i18next
    .init({

        resources:{
            en:{
                translation: enUsTrans
            },
            zh:{
                translation: zhUsTrans
            },
        },
        
        lng: defaultLng,
        fallbackLng: defaultLng,
        debug: false,
        interpolation:{
            escapeValue:false
        }
    });
 export default i18n;



